import React, { memo, forwardRef } from "react";
const SvgAlphabetF = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.48 15.91c-.227 0-.413-.033-.56-.1a1.009 1.009 0 01-.32-.24.902.902 0 01-.16-.32 1.43 1.43 0 01-.04-.3c0-.08.013-.173.04-.28a.732.732 0 01.16-.3.888.888 0 01.32-.26c.147-.08.333-.12.56-.12h.92v-1.42c0-.573.06-1.12.18-1.64.12-.533.32-1 .6-1.4.293-.4.673-.713 1.14-.94.48-.24 1.067-.36 1.76-.36 1.013 0 1.52.353 1.52 1.06 0 .267-.093.5-.28.7-.173.187-.453.28-.84.28-.653 0-1.1.193-1.34.58-.227.373-.34.9-.34 1.58v1.56h1.32c.227 0 .407.04.54.12.147.067.26.153.34.26.08.093.133.193.16.3.027.107.04.2.04.28 0 .08-.013.18-.04.3a.902.902 0 01-.16.32.966.966 0 01-.34.24c-.133.067-.313.1-.54.1H16.8v6.52c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.093 0-.213-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-6.52h-.92z"
      />
    </svg>
  );
});
SvgAlphabetF.displayName = "SvgAlphabetF";
const MemoForwardRef = memo(SvgAlphabetF);
export default MemoForwardRef;
